import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { COLOR_ERROR } from 'src/constants/theme'

import FailedStatus from '../common/FailedStatus'

const AccountCreationFailed = ({ label, onSubmit }) => {
  const { t } = useTranslation()
  return (
    <FailedStatus
      title={t('common.something-went-wrong')}
      description={t(label)}
      icon={faTimesCircle}
      color={COLOR_ERROR}
      onSubmit={onSubmit}
      t={t}
    />
  )
}

export default memo(AccountCreationFailed)
